import { useMutation } from '@sequencehq/api/utils'
import { useNotifications } from '@sequencehq/core-components'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'

const NOTIFICATION_MESSAGES = {
  SUCCESS: 'Payment retry initiated',
  ERROR: 'Failed to retry payment'
} as const

interface UseStripeRetryPaymentWidgetProps {
  invoiceId: string
}

export const useStripeRetryPaymentWidget = (
  props: UseStripeRetryPaymentWidgetProps
) => {
  const { displayNotification } = useNotifications()

  const retryPaymentMutation = useMutation(
    dashboard20240730Client.postRetryInvoicePayment,
    {
      onSuccess: () => {
        displayNotification(NOTIFICATION_MESSAGES.SUCCESS, {
          type: 'success'
        })
      },
      onError: () => {
        displayNotification(NOTIFICATION_MESSAGES.ERROR, {
          type: 'error'
        })
      }
    }
  )

  return {
    isLoading: retryPaymentMutation.isPending,
    retryPayment: () => retryPaymentMutation.mutate({ id: props.invoiceId })
  }
}
